export default {
  disabled: {
    default: [
      'PRCLSEL-PKG'
    ]
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/data/mail-classes.js